// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__1iiO7","icon":"style_icon__gssO8"};